import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import CommentPost from 'flarum/forum/components/CommentPost';
import materialUrl from './service/materialUrl';
export default function addMaterialComplaintControl() {
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    const url = materialUrl(post);

    // Действие расположено в штатной строке каждого сообщения: правообладатель видит его там,
    // где принимает решение о жалобе, а форма сразу получает точную ссылку на материал.
    items.add('devconnect-content-complaint', m(LinkButton, {
      className: 'Button Button--link dc-material-complaint-button',
      icon: 'far fa-flag',
      href: `/report-content?url=${encodeURIComponent(url)}`
    }, 'Пожаловаться'), 100);
  });
}